import reducers from "./signUpReducers";

export default reducers;
